export default __webpack_public_path__ + "static/Blockchain-bd19feab74288aff9e009da68b689bac.webp";